import _ from "lodash";

export default (hours, minutes, seconds) => {
  const htxt = _.toString(hours).length === 1 ? `0${hours}` : hours;
  const mtxt = _.toString(minutes).length === 1 ? `0${minutes}` : minutes;
  const stxt = _.toString(seconds).length === 1 ? `0${seconds}` : seconds;

  return `${htxt}:${mtxt}:${stxt}`;
};
